// index.js
import processRequest from "./utils/processRequest.js";
import showFormPannel from "./utils/showFormPannel.js";
import OpenCloseStatus from "./utils/openCloseStatus.js";
import chatHistory from "./utils/chatMemory.js";
import ShadowDOMManager from "./utils/shadow-dom.js";

document.addEventListener('DOMContentLoaded', async () => {
    console.log('DOM fully loaded and parsed');
    
    try {
        console.log('Initializing chat components');
        
        // Initialize Shadow DOM first
        window.shadowDOM = new ShadowDOMManager();
        
        // Wait for shadow DOM to be ready
        await new Promise(resolve => setTimeout(resolve, 100));
        
        // Initialize other components within the shadow DOM context
        window.openCloseStatus = new OpenCloseStatus();
        window.chatMemory = new chatHistory();
        window.showFormPannel = new showFormPannel();
        window.processRequest = new processRequest();
        
        console.log('Chat components initialized');
    } catch (error) {
        console.error('Error initializing chat:', error);
    }
});